// LINKS
// External Links
export const GOOGLE_API_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&loading=async&libraries=places`;

export const JIRA_HELP_DESK_WIDGET_KEY = "b8b607ea-6c8b-42e0-9293-8b349e7df027";
export const JIRA_HELP_DESK_WIDGET_URL = "https://jsd-widget.atlassian.com";

// COMPANY
// Info and Links
export const COMPANY_DOMAIN = "https://www.autosled.com";
export const COMPANY_PHONE = "240-880-2702";
export const COMPANY_PAYMENTS_PHONE = "1-877-726-8675";
export const COMPANY_SUPPORT_EMAIL = "support@autosled.com";
export const COMPANY_SALES_EMAIL = "sales@autosled.com";
export const COMPANY_PAYMENT_EMAIL = "payment@autosled.com";
export const COMPANY_PAYMENTS_EMAIL = "payments@autosled.com";
export const COMPANY_INFO_EMAIL = "info@autosled.com";
export const COMPANY_PRIVACY_POLICY_URL = `${COMPANY_DOMAIN}/privacy-policy`;
export const COMPANY_TRANSPORTER_REGISTRATION_URL =
  "https://mycarrierpackets.com/098e6034-8669-4039-8bd4-76be29746888/Carrier/Intellivite";

export const MIN_INCHES = 0;
export const MAX_INCHES = 1000;
export const LOW_MARGIN_PERCENTAGE = 15;
export const VIN_LENGTH = 17;
export const MIN_VIN_LENGTH = 8;
export const MIN_DISTANCE = 0;
export const MAX_DISTANCE = 4000;
export const MIN_VEHICLES = 1;
export const MAX_VEHICLES = 9;

export const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const EMAIL_REGEX = /^[A-Z0-9_%+-]+(?:\.[A-Z0-9_%+-]+)*@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const OTP_REGEX = /^[0-9]{6}$/;
export const PHONE_NUMBER_REGEX = /^(\+1)?\s?\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
export const ZIP_CODE_REGEX = /^\d{5}$/;
export const URL_REGEX =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_/.~#?&=+]*)$/;

export const UNSUPPORTED_COUNTRIES_FOR_MOBILE_PHONE_NUMBER = [
  "af",
  "by",
  "mm",
  "cf",
  "cn",
  "cd",
  "cu",
  "et",
  "hk",
  "id",
  "ir",
  "iq",
  "lb",
  "ly",
  "ml",
  "ni",
  "kp",
  "ru",
  "so",
  "ss",
  "sd",
  "sy",
  "ve",
  "vn",
  "ye",
];
